export const LS_SESSION_ID = "sessionId";
export const LS_USER = "user";
export const LS_USERNAME = "username";
// Caller's company privileges (raw object as returned by /api/login/).
// Used by useCompanyPrivileges() to derive shows_ptf / shows_price.
export const LS_COMPANY_PRIVILEGES = "companyPrivileges";
// 7HAI-544: caller's company EULA acceptance state (license JSONB as returned
// by /api/login/: { valid, accepted, acceptor, version }). Used to gate the
// company-wide EULA — admin accepts, non-admin waits for admin.
export const LS_COMPANY_LICENSE = "companyLicense";
// 7HAI-972: caller's company DPA acceptance state (`company_dpa` as returned by
// /api/login/: { accepted, acceptor, version, required_version, current }).
// Company-wide like the EULA — an admin accepts, a non-admin waits for them.
export const LS_COMPANY_DPA = "companyDpa";
